import {
  CONTENT_PROVIDERS_URL,
  CONTENT_PROVIDER_URL,
  SEARCH_CONTENT_PROVIDERS_URL,
  PORTAL_CONTENT_PROVIDERS_URL
} from 'app/utils/Constants';

import {
  get,
  post,
  put,
  patch
} from 'app/services/ApiService';

export const getContentProviders = async params => {
  return await post(SEARCH_CONTENT_PROVIDERS_URL(), params);
}

export const createContentProvider = async (params) => {
  return await post(PORTAL_CONTENT_PROVIDERS_URL(), params);
}

export const updateContentProvider = async (id, params) => {
  return await put(PORTAL_CONTENT_PROVIDERS_URL(), params);
}

export const destroyContentProvider = async (ids) => {
  let params = { ids };
  return await patch(PORTAL_CONTENT_PROVIDERS_URL(), params);
}